var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.789062,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#F1F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 28.2891V18.9141H15V37.6641H27.5",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37.6641C36.7259 37.6641 38.125 36.265 38.125 34.5391C38.125 32.8132 36.7259 31.4141 35 31.4141C33.2741 31.4141 31.875 32.8132 31.875 34.5391C31.875 36.265 33.2741 37.6641 35 37.6641Z",
    stroke: "#2698EB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 36.4141L40 38.2891M15 18.9141L27.5 28.2891L40 18.9141",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSearch;